<script setup>
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useMapGetter } from 'dashboard/composables/store';
import {
  easterEggTrigger,
  useKonamiCode,
} from 'dashboard/composables/useEasterEgg';

const FLIGHT_DURATION_MS = 4500;

const { t } = useI18n();
const globalConfig = useMapGetter('globalConfig/get');
let isFlying = false;

useKonamiCode();

const flightPath = ({ innerWidth: width, innerHeight: height }) => [
  { transform: `translate(-120px, ${height * 0.65}px) rotate(-12deg)` },
  {
    transform: `translate(${width * 0.28}px, ${height * 0.25}px) rotate(8deg) scale(1.2)`,
    offset: 0.3,
  },
  {
    transform: `translate(${width * 0.6}px, ${height * 0.55}px) rotate(-8deg) scale(1)`,
    offset: 0.6,
  },
  {
    transform: `translate(${width + 120}px, ${height * 0.12}px) rotate(-14deg)`,
  },
];

const fly = () => {
  if (isFlying) return;
  const sayNevermore = () => useAlert(t('EASTER_EGG.NEVERMORE'));
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    sayNevermore();
    return;
  }

  isFlying = true;
  const raven = document.createElement('img');
  raven.src =
    globalConfig.value.logoThumbnail || '/brand-assets/corvus-icon.png';
  raven.className =
    'fixed top-0 left-0 z-[9999] size-16 object-contain pointer-events-none drop-shadow-lg';
  document.body.appendChild(raven);

  raven.animate(flightPath(window), {
    duration: FLIGHT_DURATION_MS,
    easing: 'ease-in-out',
  }).onfinish = () => {
    raven.remove();
    isFlying = false;
    sayNevermore();
  };
};

watch(easterEggTrigger, fly);
</script>

<template>
  <span class="hidden" />
</template>
